// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"28dbc3cb","438":"c03216a5","455":"53e1d7c2","654":"7418d335","661":"adefc42b","977":"c868f4df"}[chunkId] + ".chunk.js";
};